import { withUserStore } from '../../contexts/UserStore'
import _ from 'lodash'
import _inflection from 'lodash-inflection'
_.mixin(_inflection)

const Lex = props => {
  const humanize = (term) => {
    return term.split(/-/).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
  }

  const getText = () => {
    let text = props.userStore.lex?.[props.term] || humanize(props.term)
    
    if (props.plural) {
      // If we have the text, pluralize it. If it's a hyphenated term, pluralize the last word
      const words = text.split(' ')
      const lastWord = words[words.length - 1]
      words[words.length - 1] = _.pluralize(lastWord)
      text = words.join(' ')
    }
    
    return text
  }

  return getText()
}

export default withUserStore(Lex)
